import { render } from "./GraphChart.vue?vue&type=template&id=781960ec"
import script from "./GraphChart.vue?vue&type=script&setup=true&lang=js"
export * from "./GraphChart.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/forge/retail.digitalhq.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/admin/ui/Pages/Graphs/GraphChart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "781960ec"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('781960ec', __exports__)) {
    api.reload('781960ec', __exports__)
  }
  
  module.hot.accept("./GraphChart.vue?vue&type=template&id=781960ec", () => {
    api.rerender('781960ec', render)
  })

}


export default __exports__